import { render } from "./tw-ws-line.vue?vue&type=template&id=85d6a890"
import script from "./tw-ws-line.vue?vue&type=script&lang=js"
export * from "./tw-ws-line.vue?vue&type=script&lang=js"
script.render = render

export default script